import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { FadeInOut } from '@ui/components/core'
import { Spinner } from '@ui/components/loaders'
import { AttributeValue, TelemetryData, Total } from '@ui/interfaces'
import { useTelemetryStore } from '@ui/stores'

import { getChartDataBy } from './WaffleUtils'
import { WaffleV2 } from './WaffleV2'

interface VisualizationProps {
  data: TelemetryData
  loading: boolean
  parentRef: React.RefObject<HTMLDivElement>
}

export const Visualization = ({ data, loading, parentRef }: VisualizationProps) => {
  const selectedKey = useTelemetryStore(useShallow((state) => state.selectedKey))

  const [chartData, setValuesData] = useState<AttributeValue[]>([])
  const [chartTotal, setTotal] = useState<Total>({
    count: 0,
    size: 0,
  })

  // useEffect(() => {
  //   if ()

  // }, [loading])

  useEffect(() => {
    if (data) {
      const chart = getChartDataBy(data, selectedKey.key, 'count')
      setValuesData(chart.data)
      setTotal(chart.total)
    }
  }, [data, selectedKey.key])

  if (!parentRef.current) {
    return
  }

  // const svg = {
  //   height: parentRef.current?.offsetHeight * 0.85,
  //   width: parentRef.current?.offsetWidth / 1.75,
  // }

  if (!data && !loading) {
    return (
      <div className="relative max-h-52">
        <p>No data available</p>
      </div>
    )
  }

  return (
    <div className="relative h-full w-full">
      {loading ? (
        <FadeInOut show={loading} className="flex h-52 w-full items-center justify-center">
          <Spinner />
        </FadeInOut>
      ) : (
        // <div className="relative max-h-52" style={{ height: parentRef.current?.offsetHeight }}>
        <WaffleV2 chartData={chartData} selectedKey={selectedKey.key} total={chartTotal} />
        // </div>/
        // <Waffle chartData={chartData} svg={svg} selectedKey={selectedKey.key} total={chartTotal} />
      )}
    </div>
  )
}
